const DialogAnnouncement = ({timestamp,field1,field2,field3,field4,field5,field6,inputValue1,inputValue2,inputValue3,inputValue4,
    inputValue5,inputValue6,date,anouncement}) => {

    return (  
        <div className="announcement2" key={timestamp}>
        <h2 style={{backgroundColor:"blue",color:"white"}}>Weekly programs </h2> <br/>
        <h3>{field1} <br/></h3> 
        <h4>{inputValue1} <br/><br/></h4> 
        <h3>{field2} <br/></h3> 
        <h4>{inputValue2} <br/><br/></h4> 
        {field3 && <h3>{field3} <br/></h3>} 
        {inputValue3&& <h4>{inputValue3} <br/><br/></h4>} 

        {field4 && field4 !=="" && <h3>{field4} <br/></h3>} 
        {inputValue4 && inputValue4 !=="" && <h4>{inputValue4} <br/><br/></h4>} 

        {field5 && field5 !=="" && <h3>{field5} <br/></h3>} 
        {inputValue5 && inputValue5 !=="" && <h4>{inputValue5} <br/><br/></h4>} 

        {field6&& field6 !=="" && <h3>{field6}  <br/></h3>}
        {inputValue6 && inputValue6 !=="" && <h4>{inputValue6} </h4>} <br/><br/>

        <h2 style={{backgroundColor:"blue",color:"white"}}>Announcement</h2> <br/>
        <h3>Date published: <p>{date} </p></h3> <br/><br/>
        <h3>Content: <p>{anouncement}</p></h3>  <br/><br/>
      </div>
    );
}
export default DialogAnnouncement;